import { connect } from 'react-redux';
import { withRouter } from '../utils/withRouter'
import ContainerFrame from './containerFrame'
import * as AC from '../actions/actionCreators'

function mapStateToProps(state) { 
	return { 
        isAuthenticated: state.profile.isAuthenticated,
        isCityZipDataLoaded: state.city.isCityZipDataLoaded
}};

function mapDispatchToProps(dispatch) {
    return({
        autoLogin: (token) => { dispatch(AC.ProfileAutoLoginStarted({ token }) ) },
        loadCityZipData: () => { dispatch(AC.CityZipDataLoadingStarted()) }
    })
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContainerFrame));